import {
  getValueFromSessionStorage,
  setValueIntoSessionStorage,
} from "Utils/Common/CommonMethods";

const ENABLED_CACHE_KEY = "authenticatorIsEnabled";

export const cacheAuthenticatorEnabled = (isEnabled: boolean) => {
  setValueIntoSessionStorage(ENABLED_CACHE_KEY, isEnabled ? "true" : "false");
};

export const readCachedAuthenticatorEnabled = (): boolean | null => {
  const value = getValueFromSessionStorage(ENABLED_CACHE_KEY);
  if (value === "true") return true;
  if (value === "false") return false;
  return null;
};
